import type { Location } from 'modules/core/lib/navigation/types'

export const navigation = {
  path: 'performance_process/performance_goals',
} as const satisfies Location
